<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card class="ma-3 col-sm-6" outlined>
        <v-card-title>Create Group</v-card-title>
        <hr class="ma-1">
        <div class="col">
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-text-field
                v-model="name"
                :rules="nameRules"
                label="Name"
                required
            ></v-text-field>

            <v-text-field
                v-model="description"
                label="Description"
            ></v-text-field>

            <v-text-field
                v-model="subdomain"
                label="Subdomain"
            >
              <v-card-text slot="append">.wallet.sg</v-card-text>
            </v-text-field>

            <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4 font-weight-bold"
                @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    valid: true,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
    ],
    description: '',
    subdomain: '',
    // subdomainRules: [
    //     v => !!v || 'Sub-domain is required',
    // ],
    breadcrumbsItems: '',
  }),
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        axios.post('/group', {
          name: this.name,
          description: this.description,
          subdomain: this.subdomain,
        }).then(function (result) {
          window.location.href = '/superadmin';
        });
      }
    }
  },
  beforeMount() {
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: 'Create Group',
      },
    ];
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Groups/GroupCreate.vue